<div class="table-container">
  <div class="header-bar">
    <h2><i class="material-icons">badge</i></h2>
    <div *ngIf="supervisor">
      <button
        class="plus"
        *ngIf="!showCreateForm"
        (click)="createDepartmentUser()"
      >
        <i class="fa fa-plus" aria-hidden="true"></i>
      </button>
    </div>
  </div>

  <div class="table-scroll">
    <table class="table">
      <thead>
        <tr></tr>
      </thead>
      <tbody>
        <tr *ngIf="showCreateForm">
          <td colspan="1">
            <div class="create-department-user-form">
              <department-user-details
                (formClosed)="onFormClosed()"
              ></department-user-details>
            </div>
          </td>
        </tr>

        <ng-container *ngFor="let departmentUser of departmentUsers | async">
          <tr>
            <td class="td user-cell">
              <span class="user-info">
                <i class="material-icons">person</i>
                {{ userLabel(departmentUser) }}
              </span>
              <button
                class="btn-delete"
                (click)="removeDepartmentUser(departmentUser)"
              >
                <span class="material-icons-outlined">cancel</span>
              </button>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>
</div>
